export default __webpack_public_path__ + "static/bg-6aa17bea714f4195904c19d96e0d6a99.png";